import { makeStyles } from '@material-ui/core/styles';

export const useFormControlLabelStyles = makeStyles({
  root: {
    padding: '0',
    backgroundColor: (props) => props.backgroundColor || props.theme.palette.background.default,
  },
});
